// @flow
import * as Immutable from 'immutable';

import TeamPreferencesActions from 'common/redux/actions/teamPreferences';
import { TeamPreferences } from 'common/models/internal/TeamPreferences';

const initialState = {
    isLoading: false,
    value: null
};

export default (state = Immutable.fromJS(initialState), action: Object) => {
    switch (action.type) {
        case TeamPreferencesActions.FETCH_TEAM_PREFERENCES_START:
            return state.set('isLoading', true);

        case TeamPreferencesActions.FETCH_TEAM_PREFERENCES_COMPLETE:
            return state.set('isLoading', false);

        case TeamPreferencesActions.INJECT_TEAM_PREFERENCES: {
            const teamPreferences = TeamPreferences.fromJS(action.response);
            const updatedState = state.set('value', teamPreferences);
            return updatedState;
        }

        default:
            return state;
    }
};
